import { X, Folder, File, Trash2 } from "lucide-react";

function CloudFileBrowserModal({
  onClose,
  loadingFiles,
  currentPath,
  bucketFiles,
  onSelectFile,
  onDeleteFile,
  onNavigateFolder,
}) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] flex flex-col">
        <div className="p-6 border-b flex items-center justify-between">
          <h3 className="text-xl font-bold text-slate-800">Cloud Storage</h3>
          <button onClick={onClose} aria-label="Close" className="text-slate-400 hover:text-slate-600">
            <X size={24} />
          </button>
        </div>

        <div className="p-6 overflow-y-auto flex-1">
          {loadingFiles ? (
            <div className="text-center py-12 text-slate-400">
              Loading files...
            </div>
          ) : (
            <div className="space-y-2">
              {currentPath && (
                <div
                  className="flex items-center gap-2 p-3 hover:bg-slate-50 rounded-lg cursor-pointer"
                  onClick={() =>
                    onNavigateFolder(
                      currentPath.split("/").slice(0, -2).join("/") + "/",
                    )
                  }
                >
                  <Folder className="w-5 h-5 text-blue-500" />
                  <span className="font-medium">.. (Back)</span>
                </div>
              )}

              {bucketFiles.length === 0 ? (
                <div className="text-center py-12 text-slate-400">
                  No files in this location
                </div>
              ) : (
                bucketFiles.map((file) => (
                  <div
                    key={file.name}
                    className="flex items-center justify-between gap-2 p-3 hover:bg-slate-50 rounded-lg transition"
                  >
                    <div
                      className="flex items-center gap-2 flex-1 cursor-pointer"
                      onClick={() =>
                        file.isDirectory ? onNavigateFolder(file.name) : null
                      }
                    >
                      {file.isDirectory ? (
                        <Folder className="w-5 h-5 text-blue-500" />
                      ) : (
                        <File className="w-5 h-5 text-slate-400" />
                      )}
                      <span className="text-sm">
                        {file.name.split("/").pop()}
                      </span>
                    </div>
                    {!file.isDirectory && (
                      <div className="flex items-center gap-1 flex-shrink-0">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            onSelectFile(file.datasetId, file.name);
                          }}
                          className="text-blue-500 hover:text-blue-700 transition px-3 py-1.5 text-sm font-medium border border-blue-200 hover:border-blue-400 rounded-md"
                          title="Select dataset"
                        >
                          Select
                        </button>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            onDeleteFile(
                              file.datasetId,
                              file.name.split("/").pop(),
                            );
                          }}
                          className="text-red-400 hover:text-red-600 transition p-1.5"
                          title="Delete dataset"
                          aria-label="Delete dataset"
                        >
                          <Trash2 className="w-5 h-5" />
                        </button>
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CloudFileBrowserModal;
